import { RouteProps } from 'react-router';
import MfCart from './ExploreMFs/mf-cart';
import MfFailure from './ExploreMFs/mf-failure';
import { CommercialActions } from './index';
import AdditionalPurchase from './AdditionalPurchase';
import APOtpVerification from './AdditionalPurchase/ap-invest-otp';
import ApInvestment from './AdditionalPurchase/ap-invest';
import { SipRoutes } from './Sip/routes';
import { NewPurchaseRoutes } from './ExploreMFs/routes';
import { SwitchRoutes } from './Switch/routes';
import { RedeemRoutes } from './Redemption/routes';
import { EmandateRoutes } from './emandate/routes';
import { CommercialRootPath as CRP } from '../../../utils/constants';
import { STPRoutes } from './STP/routes';
import { SWPRoutes } from './SWP/routes';

export const CommercialRootPath = CRP

export const CommercialRoutes: RouteProps[] = [
    {
        path: `/actions`,
        component: CommercialActions,
    },
    {
        path: `/additional-purchase`,
        component: AdditionalPurchase,
    },
    {
        path: '/ap-investment/:folioNo',
        component: ApInvestment,
    },
    {
        path: '/ap/verify-otp',
        component: APOtpVerification,
    },
    {
        path: `/mf-cart`,
        component: MfCart,
    },
    {
        path: `/mf-failure`,
        component: MfFailure,
    },
    ...SipRoutes,
    ...NewPurchaseRoutes,
    ...SwitchRoutes,
    ...RedeemRoutes,
    ...EmandateRoutes,
    ...STPRoutes,
    ...SWPRoutes,
];
